module.exports = __webpack_public_path__ + "media/assets/images/person_shadow_gray-ddce4c491e1a8d5e3d6721b522cb91e2.png";